import React from 'react';
import PropTypes from 'prop-types';
import Dotdotdot from 'react-dotdotdot';
import Link from 'gatsby-link';
import './news-preview.css';

import placeholder from '../../images/placeholder.jpg';

class NewsPreview extends React.Component {


  static propTypes = {
    image: PropTypes.string,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    first: PropTypes.bool,
    link: PropTypes.string.isRequired
  }

  static defaultProps = {
    image: placeholder,
    title: "Hello World",
    description: "A sample description",
    first: false
  }

  render() {

    let classNm = "";
    this.props.first ? classNm = "col-xs-12 col-sm-12 col-md-12 col-lg-offset-1 col-lg-5 col-xl-5" : classNm = "col-xs-12 col-sm-12 col-md-12 col-lg-5 col-xl-5";

    return (
      <div className={"news-preview-container " + classNm}>
        <a href={this.props.link}>
        <div className={"news-preview"}>
        <div className={"news-preview-image col-xs-6 col-lg-4"}>
          <img src={this.props.image}></img>
        </div>
        <div className={"news-preview-content col-xs-6 col-lg-8"}>
          <h4>{this.props.title}</h4>
          <Dotdotdot clamp={2}>
            <p>{this.props.description}</p>
          </Dotdotdot>
        </div>
        </div>
        </a>
      </div>
    )
  }
}

export default NewsPreview;



// WEBPACK FOOTER //
// ./src/components/NewsPreview/news-preview.js